<template>
  <div class="checkBox_head ">
    <div class="search">
      <span class="current_tit">当前区域：</span>
      <div class="margin-right_20">
        <span>{{location.site}}</span>
        <span v-if="location.site">附近{{toThousands}}以内公司</span>
      </div>
    </div>
    <searchHeadCheckBox :key="datekey" searchType="6" :hideSome='false' @set-condition="setCondition" class="search-add-content"></searchHeadCheckBox>
    <!-- <dl :class="['checkBoxes',{'checkBox_head_height':!expand}]">
      <dd class="clearfix" v-if="industry.list.length">
        <div class="title">{{industryTitle}}</div>
        <div class="selectBox selectBox2 border_bottom" :class="{'noheight': industry.showMore}">
          <span v-for="(j,index) in industry.list" :key="index" @click="chooseIndustry(j,index)">{{j.name}}</span>
        </div>
        <div :class="['showMore',{'is-opened':industry.showMore}]" v-show="showMoreBtn2" @click="showMore(industry)">{{!industry.showMore?'更多':'收起'}}
          <i class="el-submenu__icon-arrow el-icon-arrow-down"></i>
        </div>
      </dd>

      <dd class="clearfix">
        <div class="title">{{createTime.title}}</div>
        <div class="selectBox">
          <el-checkbox-group v-model="createTime.select">
            <el-checkbox v-for="(item,index) in createTime.list" :key="index" :label="item"></el-checkbox>
          </el-checkbox-group>
        </div>
      </dd>
      <dd class="clearfix">
        <div class="title">{{money.title}}</div>
        <div class="selectBox">
          <el-checkbox-group v-model="money.select">
            <el-checkbox v-for="(item,index) in money.list" :key="index" :label="item"></el-checkbox>
          </el-checkbox-group>
        </div>
      </dd>
      <dd class="clearfix">
        <div class="title" style="color:rgba(255, 160, 0, 1)">高级筛选</div>
        <div class="selectBox">
          <el-dropdown v-if="!hideSome" trigger="click" @command="dropHandle">
            <span class="el-dropdown-link font-13">人员规模<i class="el-icon-arrow-down el-icon--right"></i></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item,i) in screen2" :key="i" :command='item'>{{item.text}} <i class="el-icon-check" v-show="item.checked"></i></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown trigger="click" @command="dropHandle">
            <span class="el-dropdown-link font-13">企业类型<i class="el-icon-arrow-down el-icon--right"></i></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item,i) in screen3" :key="i" :command='item'>{{item.text}} <i class="el-icon-check" v-show="item.checked"></i></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown v-if="!hideSome" trigger="click" @command="dropHandle">
            <span class="el-dropdown-link font-13">公司实力<i class="el-icon-arrow-down el-icon--right"></i></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item,i) in screen4" :key="i" :command='item'>{{item.text}} <i class="el-icon-check" v-show="item.checked"></i></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown v-if="!hideSome" trigger="click" @command="(item) => {dropHandle(item,5)}">
            <span class="el-dropdown-link font-13">有无手机<i class="el-icon-arrow-down el-icon--right"></i></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item,i) in screen5" :key="i" :command='item'>{{item.text}} <i class="el-icon-check" v-show="item.checked"></i></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </dd>
      <transition name="el-fade-in-linear">
        <dd v-show="selectedList.length" class="clearfix colorBg">
          <div class="title">已选条件</div>
          <div class="selectBox selectBox_noheight">
            <el-tag :key="tag.value" v-for="(tag) in selectedList" closable :disable-transitions="false" @close="handleClose(tag)">
              {{tag.text}}
            </el-tag>
          </div>
        </dd>
      </transition>

    </dl>
    <div :class="{'zzhao':!expand}" @click="expand=!expand"></div>
    <div class="search-save">筛选条件</div>
    <div class="search-expand-btn">
      <div :class="['expand', 'toggle-btn', 'font-12',!expand?'':'show']" @click="expand=!expand">{{expand?'收起':'展开'}}</div>
    </div> -->
  </div>
</template>

<script>
import category from '@/base/category.js'
import { areaCode } from '@/base/areaCode.js'
import btnBg from '@/assets/topRightBtnbg.png'
import searchHeadCheckBox from '@/views/clue/components/searchHeadCheckBox'

export default {
  components: {
    searchHeadCheckBox
  },
  name: 'mapHeadCheckBox',
  data () {
    return {
      btnBg,
      word: '',
      expand: false,
      showMoreBtn1: true,
      showMoreBtn2: true,
      category,
      areaCode,
      city: { title: '省份地区', showMore: false, list: [], select: [] },
      industry: { title: '行业分类', showMore: false, list: [], select: [] },

      // 其他筛选
      createTime: {
        title: '成立年限',
        list: ['1个月以内', '1-12个月', '1-3年', '3-5年', '5-10年', '10年以上'],
        select: []
      },
      money: {
        title: '注册资本',
        list: ['100万以下', '100万-1000万', '1000万-1亿', '1亿-10亿', '10亿以上'],
        select: []
      },
      screen1: [{ text: '在营', checked: false }, { text: '非在营', checked: false }],
      screen2: [
        // { text: '10人以内', checked: false },
        // { text: '10-50人', checked: false, search: '10-50' },
        // { text: '50-100人', checked: false, search: '50-100' },
        // { text: '100-500人', checked: false, search: '100-500' },
        // { text: '500-1000人', checked: false, search: '500-1000' },
        // { text: '1000-5000人', checked: false, search: '1000-5000' },
        // { text: '5000-10000人', checked: false, search: '5000-10000' },
        // { text: '10000人以上', checked: false, search: '10000以上' }
        { text: '50人以内', checked: false },
        { text: '50-99人', checked: false, search: '50-99' },
        { text: '100-499人', checked: false, search: '100-499' },
        { text: '500-999人', checked: false, search: '500-999' },
        { text: '1000-4999人', checked: false, search: '1000-4999' },
        { text: '5000-9999人', checked: false, search: '5000-9999' },
        { text: '10000人以上', checked: false, search: '10000人以上' }
      ],
      screen3: [
        { text: '股份有限公司', checked: false }, { text: '有限责任公司', checked: false },
        { text: '股份合作公司', checked: false }, { text: '个体工商户', checked: false },
        { text: '农村专业合作社', checked: false }, { text: '集体所有制', checked: false },
        { text: '有限合伙', checked: false }, { text: '普通合伙', checked: false },
        { text: '联营企业', checked: false }, { text: '港、澳、台投资企业', checked: false },
        { text: '外商投资企业', checked: false }, { text: '国有企业', checked: false },
        { text: '独资企业', checked: false }, { text: '其他', checked: false }
        ],
      screen4: [
        { text: '独角兽', checked: false, search: '独角兽企业' }, { text: '瞪羚企业', checked: false, search: '瞪羚企业' },
        { text: '创新企业', checked: false, search: '技术创新示范企业' }, // { text: '规模以上', checked: false },
        { text: '高新企业', checked: false, search: '高新技术企业' }, { text: '央企', checked: false, search: '央企' },
        { text: '中国500强', checked: false, search: '中国500强' }, { text: '世界500强', checked: false, search: '世界500强' }
      ],
      screen5: [
        { text: '有手机号', checked: false, search: 1 },
        { text: '无手机号', checked: false, search: 0 }
      ],

      // customMoney: [], // 自定义金额列表
      // customYear: [], // 自定义年份列表
      categoryId: '',
      areaCodeId: '',

      cityHistory: [],
      industryHistory: [], // 行业历史记录，删除时用到
      last: 1,
      datekey:Date.now()
    }
  },
  props: {
    location: {
      type: Object,
      default: () => ({ site: null, latitude: null, longtitude: null, distance: 0 })
    },
    // 1： 商机线索，2：新增企业 （用来筛选不同字段）
    searchType: {
      type: String,
      default: '1'
    },
    hideSome: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selectedList: {
      get () {
        const arr1 = this.screen1.filter(e => e.checked).map(e => { return { ...e, source: 'screen1' } })
        const arr2 = this.screen2.filter(e => e.checked).map(e => { return { ...e, source: 'screen2' } })
        const arr3 = this.screen3.filter(e => e.checked).map(e => { return { ...e, source: 'screen3' } })
        const arr4 = this.screen4.filter(e => e.checked).map(e => { return { ...e, source: 'screen4' } })
        const arr5 = this.createTime.select.map((e, index) => { return { text: e, index, source: 'createTime' } })
        const arr6 = this.money.select.map((e, index) => { return { text: e, index, source: 'money' } })
        const arr7 = this.screen5.filter(e => e.checked).map(e => { return { ...e, source: 'screen5' } })

        setTimeout(() => {
          this.$nextTick(() => {
            if (this.searchType === '1') {
              this.requestParams()
            } else if (this.searchType === '2') {
              this.requestParams2()
            }
          })
        }, 200)

        return [...this.city.select, ...this.industry.select, ...arr5, ...arr6, ...arr1, ...arr2, ...arr3, ...arr4, ...arr7]
      }
    },
    cityLv () {
      return this.cityHistory.length + 1
    },
    cityTitle () {
      let str = '省份地区'
      this.cityLv === 2 ? str = '城市' : null
      return str
    },
    industryLv () {
      return this.industryHistory.length + 1
    },
    industryTitle () {
      let str = '业务行业'
      if (this.industryLv === 2) str = '二级行业'
      if (this.industryLv === 3) str = '三级行业'
      return str
    },
    toThousands () {
      let num = this.location.distance
      num = (num / 1000)
      if (num > 1) {
        num = parseInt(num)
        num = (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        return num + 'KM'
      } else {
        num = parseInt(num * 1000)
        num = (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        return num + 'M'
      }
    }

  },
  mounted () {
    this.setCityList()
    this.setIndustryList()
    window.addEventListener('resize', this.hasShowMoreBtn)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.hasShowMoreBtn)
    })
  },

  watch: {
    'city.select.length': {
      handler (val) {
        if (!val) {
          this.cityHistory = []
          this.setCityList()
        }
      }
    },
    'industry.select.length': {
      handler (val) {
        if (!val) {
          this.industryHistory = []
          this.setIndustryList()
        }
      }
    },
    // 搜索
    'selectedList.length' (val) {
      // if (this.searchType === '1') {
      //   this.requestParams()
      // } else if (this.searchType === '2') {
      //   this.requestParams2()
      // }
    },
    '$route.query.word': {
      immediate: true,
      handler (val) {
        this.word = val
      }
    }

  },
  methods: {
    refreshDatekey(){
       this.datekey = Date.now()
    },
    setCondition (val) {
      this.$emit('set-condition', val)
    },
    hasShowMoreBtn () {
      this.$nextTick(() => {
        const r = document.querySelector('.checkBoxes')
        let rw
        if (r) {
          rw = r.offsetWidth - 240
        } else {
          return
        }
        const selectBox1 = document.querySelector('.selectBox1')
        if (selectBox1) {
          const selectBox1w = selectBox1.offsetWidth
          if (selectBox1w < rw - 200) {
            this.showMoreBtn1 = false
          }
        }
        const selectBox2 = document.querySelector('.selectBox2')
        if (selectBox2) {
          const selectBox2w = selectBox2.offsetWidth
          if (selectBox2w < rw - 200) {
            this.showMoreBtn2 = false
          }
        }
      })
    },
    /*
    * 设置城市列表 目前只有两级
    */
    setCityList () {
      this.city.list.length = 0
      if (this.cityLv === 1) {
        areaCode.forEach(e => {
          this.city.list.push({ name: e.name, areaCodeId: e.areaCode })
        })
      } else if (this.cityLv === 2) {
        const cityObj = areaCode[this.cityHistory[this.cityHistory.length - 1]].children
        if (cityObj.length > 2) {
          cityObj.forEach(e => {
            this.city.list.push({ name: e.name, areaCodeId: e.areaCode })
          })
        }
      }
    },
    /*
    * 设置职业列表 目前2级  (之前三级)        *******************
    */
    setIndustryList () {
      this.industry.list.length = 0
      // 一级
      if (this.industryLv === 1) {
        this.category.forEach(e => {
          this.industry.list.push({ name: e.label, categoryId: e.value })
        })
      } else if (this.industryLv === 2) { // 三级职业逻辑跟2级一样， 全部走这里（else if 改为 else）
        let industryObj = []
        this.industryHistory.forEach((e, index) => {
          if (index === 0) {
            industryObj = this.category[e].children
          } else {
            industryObj = industryObj[e].children
          }
        })

        industryObj && industryObj.forEach(e => {
          this.industry.list.push({ name: e.label, categoryId: e.value })
        })
      }
    },

    dropHandle (item, sign) {
      if (sign === 5) {
        this.screen5.forEach(e => {
          e.checked = false
        })
      }
      item.checked = true
    },

    clearAllSelect () {
      this.city.select = []
      this.industry.select = []
      this.createTime.select = []
      this.money.select = []
      for (let i = 1; i < 6; i++) {
        this['screen' + i].forEach(e => e.checked = false)
      }
    },
    // 参数整理
    requestParams () {
      const params = {
        estiblishTime: [], // 成立时间
        regCapital: [], // 注册资本
        regStatus: [], // 经营状态
        staffSize: [], // 人员规模
        companyType: [], // 企业规模
        tags: [], // 实力标签
        hasPhone: []// 有无手机号
      }
      // type 1为位置信息 2为职业信息
      this.selectedList.forEach(e => {
        if (e.type === 1) {
          if (e.lv === 1) params.province = e.text
          if (e.lv === 2) params.city = e.text
        }
        if (e.type === 2) {
          if (e.lv === 1) params.bigIndustry = e.text
          if (e.lv === 2) params.smallIndustry = e.text
        }
        if (e.source) {
          // 查询数据对应字段
          const obj = {
            createTime: 'estiblishTime',
            money: 'regCapital',
            screen1: 'regStatus',
            screen2: 'staffSize',
            screen3: 'companyType',
            screen4: 'tags',
            screen5: 'hasPhone'
          }
          params[obj[e.source]].push(e.search || (e.search == 0 ? 0 : e.text))
        }
      })
      // 删除空数组
      for (const item in params) {
        if (params[item] instanceof Array) {
          if (!params[item].length) {
            delete params[item]
          }
        }
      }
      this.$emit('set-condition', params)
    },
    requestParams2 () {
      const params = {
        estiblishTime: [], // 成立时间
        regCapital: [], // 注册资本
        regStatus: [], // 经营状态
        staffSize: [], // 人员规模
        companyType: [], // 企业规模
        tags: [], // 实力标签
        hasPhone: []// 有无手机号
      }
      // type 1为位置信息 2为职业信息
      this.selectedList.forEach(e => {
        if (e.type === 1) {
          if (e.lv === 1) params.province = e.areaCodeId
          if (e.lv === 2) params.city = e.areaCodeId.substr(e.areaCodeId.length - 2, e.areaCodeId.length)
        }
        if (e.type === 2) {
          if (e.lv === 1) params.industryCode = e.categoryId
          if (e.lv === 2) params.subIndustryCode = e.categoryId
        }
        if (e.source) {
          // 查询数据对应字段
          const obj = {
            createTime: 'estiblishTime',
            money: 'regCapital',
            screen1: 'regStatus',
            screen2: 'staffSize',
            screen3: 'companyType',
            screen4: 'tags',
            screen5: 'hasPhone'
          }
          params[obj[e.source]].push(e.search || (e.search == 0 ? 0 : e.text))
        }
      })

      // 删除空数组
      for (const item in params) {
        if (params[item] instanceof Array) {
          if (!params[item].length) {
            delete params[item]
          }
        }
      }

      this.$emit('set-condition', params)
    },
    showMore (item, dom) {
      item.showMore = !item.showMore
    },

    handleClose (tag) {
      if (tag.type === 1) {
        this.findItem(this.city.select, tag.text)
        //  this.cityHistory = this.cityHistory.reverse().splice(0,tag.lv).reverse()
        if (tag.lv === 1) {
          this.deleteAllCity()
        }
        if (tag.lv === 2) {
          this.cityHistory.pop()
          this.setCityList()
        }
      } else if (tag.type === 2) {
        const len = this.industryHistory.length
        const start = tag.lv - 1
        const num = len - start
        this.industryHistory.splice(start, num)
        this.deleteNextLvIndustry()
        this.setIndustryList()
      } else if (tag.source) {
        if (tag.hasOwnProperty('index')) {
          this[tag.source].select.splice(tag.index, 1)
        } else {
          this[tag.source].forEach(e => {
            if (e.text === tag.text) e.checked = false
          })
        }
      }

      // this.findItem(this.createTime.select, tag)
      // this.findItem(this.money.select, tag)
      // this.findItem(this.customYear, tag)
      // this.findItem(this.customMoney, tag)
    },
    deleteAllCity () {
      this.city.select.length = 0
    },

    deleteNextLvIndustry () {
      this.industry.select = this.industry.select.filter(e => e.lv < this.industryLv)
    },
    findItem (arr, text) {
      for (let i = 0; i < arr.length; i++) {
        if ((arr[i].text || arr[i]) === text) {
          arr.splice(i, 1)
          break
        }
      }
    },
    // 选择城市
    chooseCity (c, index) {
      this.city.select.push({ type: 1, text: c.name, areaCodeId: c.areaCodeId, lv: this.cityLv })
      this.cityHistory.push(index)
      this.setCityList()
      this.hasShowMoreBtn()
    },
    // 选择职业
    chooseIndustry (i, index) {
      this.industry.select.push({ type: 2, text: i.name, categoryId: i.categoryId, lv: this.industryLv })
      this.industryHistory.push(index)
      this.setIndustryList()
      this.hasShowMoreBtn()
    }
  }
}
</script>
<style lang="scss" scoped>
.checkBox_head {
  position: relative;
   /deep/ .search-add-content.checkBox_head .checkBoxes dd .selectBox{
    max-width: calc(100% - 150px);
    .el-checkbox{
      min-width: 100px;
      margin-right:10px;
    }
  }

  .search {
    width: 80%;
    min-width: 600px;
    display: flex;
    line-height: 14px;
    padding: 8px 0 13px 0px;
    box-sizing: border-box;
    > span {
      flex-grow: 0;
      flex-shrink: 0;
      color: #999999;
      margin-right: 8px;
      font-size: 13px;
      margin-top: 1px;
    }
    > div {
      flex-grow: 1;
      flex-shrink: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      span{
        font-size: 13px;
      }
    }
  }
  // .checkBoxes {
  //   background-color: #fff;
  //   border-radius: 7px 0 0 0;
  //   margin-top: 10px;
  //   padding-top: 10px;
  //   position: relative;
  //   padding-bottom: 10px;
  //   // height: auto;
  //   // transition: .4s height;
  //   .colorBg {
  //     background: rgba(245,246,248,0.6);
  //   }
  //   dd {
  //     line-height: 40px;
  //     padding: 0 22px;
  //     box-sizing: border-box;
  //     position: relative;
  //     .title {
  //       font-size: 14px;
  //       margin-right: 24px;
  //       float: left;
  //       font-weight: bold;
  //     }

  //     .selectBox {
  //       float: left;
  //       max-width: calc(100% - 150px);
  //       overflow: hidden;
  //       height: 40px;
  //       > span {
  //         display: inline-block;
  //         font-size: 13px;
  //         margin-right: 40px;
  //         cursor: pointer;
  //       }
  //       > span:hover {
  //         color: rgb(28, 122, 230);
  //       }
  //       /deep/ .el-dropdown {
  //         margin-right: 40px;
  //         cursor: pointer;
  //       }
  //       /deep/ .el-checkbox-group {
  //         height: 40px;
  //         float: left;
  //         .el-checkbox:hover .el-checkbox__label {
  //           color: rgb(28, 122, 230);
  //         }
  //         .el-checkbox__label {
  //           font-size: 13px;
  //           position: relative;
  //           top: -1px;
  //         }
  //       }
  //       .custom {
  //         cursor: pointer;
  //         margin-left: 30px;
  //         font-size: 12px;
  //       }
  //       /deep/ .el-tag {
  //         height: 24px;
  //         line-height: 24px;
  //         background: rgba(80,136,255,0.2);
  //         border-radius: 3px;
  //         padding: 0 8px 0 10px;
  //         box-sizing: border-box;
  //         border-color: transparent;
  //         color: #5088FF;
  //         font-size: 12px;
  //         margin-right: 8px;
  //       }
  //     }

  //     .selectBox_noheight {
  //       height: auto;
  //     }
  //     .noheight {
  //       height: 100%;
  //     }
  //     .border_bottom {
  //       border-bottom: 1px solid #f2f2f2;
  //       // max-width: calc(100% - 81px);
  //       max-width: calc(100% - 83px);
  //       padding-right: 200px;
  //       box-sizing: border-box;
  //     }
  //     .showMore {
  //       cursor: pointer;
  //       font-size: 13px;
  //       // color: #999;
  //       float: right;
  //       // position: relative;
  //       position: absolute;
  //       right: 0;
  //       width: 66px;
  //       color: rgba(51,51,51,0.5);
  //       &.is-opened .el-submenu__icon-arrow {
  //         transform: rotate(180deg);
  //       }
  //     }
  //   }

  //   &.checkBox_head_height {
  //     // height: 49px;
  //     height: 63px;
  //     overflow: hidden;
  //   }
  // }

  // .zzhao {
  //   height: 49px;
  //   // height: 25px;
  //   width: 100%;
  //   cursor: pointer;
  //   position: absolute;
  //   bottom: 0;
  //   border-radius: 4px;
  //   // background-image: linear-gradient(
  //   //   180deg,
  //   //   rgba(255, 255, 255, 0) 0%,
  //   //   #fff 100%
  //   // );
  //   background-image: url("~@/assets/gbIcon/wbg.png");
  //   background-position: bottom;
  //   background-repeat: repeat-x;
  //   z-index: 1;
  //   bottom: -1px;
  // }
  // .search-save {
  //   // background: url("~@/assets/topRightBtnbg.png") no-repeat;
  //   background: url("~@/assets/gbIcon/topRightBtnbg.png") no-repeat;
  //   background-size: contain;
  //   position: absolute;
  //   width: 118px;
  //   height: 41px;
  //   right: 0;
  //   top: 5px;
  //   padding: 16px 10px 0px 30px;
  //   color: #5088FF;
  //   text-align: center;
  //   // cursor: pointer;
  //   box-sizing: border-box;
  // }
  // .search-expand-btn {
  //   position: absolute;
  //   width: 100%;
  //   .expand {
  //     width: 77px;
  //     height: 20px;
  //     margin: 0 auto;
  //     // line-height: 20px;
  //     // text-align: center;
  //     // background-image: url("~@/assets/search-expand-bg.png");
  //     background-image: url("~@/assets/gbIcon/search-expand-bg.png");
  //     background-size: 100%;
  //     color: #999;
  //     cursor: pointer;
  //     position: relative;
  //     padding-left: 18px;
  //     box-sizing: border-box;
  //     font-size: 13px;
  //     &::after{
  //         position: absolute;
  //         content: '';
  //         width:7px;
  //         height:7px;
  //         display: block;
  //         right: 16px;
  //         top: 0;
  //         bottom: 5px;
  //         margin: auto;
  //         border-left: 1px solid rgba(52,57,81,0.5);
  //         border-bottom: 1px solid rgba(52,57,81,0.5);
  //         transform: rotate(-45deg);
  //     }
  //     &.show{
  //       &::after{
  //         transform: rotate(135deg);
  //         bottom: 0;
  //       }
  //     }
  //   }
  // }
}

</style>
